import * as React from "react";
import { ChatProvider } from "../../context/chat/chat.context";
import { ChatPageBodyComponent } from "../../components/chat-page-body/chat-page-body.component";

export const ChatPage = () => {
    return (
        <ChatProvider>
            <div className="#f5f5f5">
                <ChatPageBodyComponent />
            </div>
        </ChatProvider>
    );
}